import { defineStyleConfig } from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'

const { FontColor } = themeColorSectionKeys.defaults

export const TextStyle = defineStyleConfig({
  baseStyle: {
    color: FontColor.Default,
    textStyle: textStyleKeys.Body2,
    mb: 0,
  },
  variants: {
    error: {
      color: FontColor.Error,
      textStyle: textStyleKeys.Body3_Bold,
    },
  },
})
